<template>
  <footer class="be-footer">
    <div class="ga-container fluid">
      <div class="be-footer__inner">
        <p class="be-footer__copyright">
          Copyright © {{ currentYear }} {{ getMerchant.name }} All Right Reserved.
        </p>

        <div class="be-footer__social" v-if="hasSocialMedia">
          <a
            v-if="$isNotEmptyV2(getMerchant.facebook_link)"
            :href="getMerchant.facebook_link"
            target="_blank"
            class="be-footer__social-icon">
            <img src="../../../../assets/img/icon/social/facebook.svg" alt="Facebook" />
          </a>
          <a
            v-if="$isNotEmptyV2(getMerchant.instagram_link)"
            :href="getMerchant.instagram_link"
            target="_blank"
            class="be-footer__social-icon">
            <img src="../../../../assets/img/icon/social/instagram.svg" alt="Instagram" />
          </a>
          <a
            v-if="$isNotEmptyV2(getMerchant.tiktok_link)"
            :href="getMerchant.tiktok_link"
            target="_blank"
            class="be-footer__social-icon">
            <img src="../../../../assets/img/icon/social/tik-tok.svg" alt="Tiktok" />
          </a>
          <a
            v-if="$isNotEmptyV2(getMerchant.tripadvisor_link)"
            :href="getMerchant.tripadvisor_link"
            target="_blank"
            class="be-footer__social-icon">
            <img src="../../../../assets/img/icon/social/tripadvisor.svg" alt="Tripadvisor" />
          </a>
          <a
            v-if="$isNotEmptyV2(getMerchant.youtube_link)"
            :href="getMerchant.youtube_link"
            target="_blank"
            class="be-footer__social-icon">
            <img src="../../../../assets/img/icon/social/youtube.svg" alt="Youtube" />
          </a>
          <a
            v-if="$isNotEmptyV2(getMerchant.website)"
            @click="openWebsite"
            class="be-footer__social-icon">
            <img src="../../../../assets/img/icon/social/website.svg" alt="Website" />
          </a>
          <a
            v-if="$isNotEmptyV2(getMerchant.whatsapp_number)"
            :href="whatsappHref"
            target="_blank"
            class="be-footer__social-icon"
            @click="$sendEventMetaConversionsAPI('Contact', 'whatsapp')">
            <img src="../../../../assets/img/icon/social/whatsapp.svg" alt="Whatsapp" />
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'BeFooter',
  computed: {
    ...mapGetters(['getMerchant']),
    currentYear() {
      return new Date().getFullYear();
    },
    hasSocialMedia() {
      const {
        facebook_link,
        instagram_link,
        tiktok_link,
        tripadvisor_link,
        youtube_link,
        website,
        whatsapp_number,
      } = this.getMerchant;

      return [
        facebook_link,
        instagram_link,
        tiktok_link,
        tripadvisor_link,
        youtube_link,
        website,
        whatsapp_number,
      ].some((link) => this.$isNotEmptyV2(link));
    },
    whatsappHref() {
      const number = this.getMerchant.whatsapp_number.substring(0, 1) === '+'
        ? this.getMerchant.whatsapp_number.substring(1)
        : this.getMerchant.whatsapp_number;
      return `https://api.whatsapp.com/send/?phone=${number}&text&app_absent=0`;
    },
  },
  methods: {
    openWebsite() {
      const url = this.getMerchant.website;
      const hasProtocol = url.startsWith('http://') || url.startsWith('https://');
      window.open(hasProtocol ? url : `http://${url}`, '_blank');
    },
  },
};
</script>

<style scoped>
.be-footer {
  border-top: 1px solid #e8e8e8;
}
.be-footer__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 24px 0;
}
.be-footer__copyright {
  margin: 0;
  font-family: var(--be-v3-content-font, BeV3Sans), sans-serif;
  font-size: 14px;
  color: #1a1a2e;
}
.be-footer__social {
  display: flex;
  align-items: center;
  gap: 10px;
}
.be-footer__social-icon {
  display: flex;
  cursor: pointer;
  transition: opacity 0.2s ease;
}
.be-footer__social-icon:hover {
  opacity: 0.8;
}
.be-footer__social-icon img {
  width: 32px;
  height: 32px;
}
@media (max-width: 575.98px) {
  .be-footer__inner {
    justify-content: center;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hotel/be/v3/BeFooter.vue